module.exports = __webpack_public_path__ + "static/media/KH.8a924cae.svg";